// extracted by mini-css-extract-plugin
export default {"layout":"Shared_layout__hmI+4","mainLayout":"Shared_mainLayout__tOPog","mainBox":"Shared_mainBox__AFLYb","userName":"Shared_userName__Oi9kH"};